<template>
  <b-card>
    <b-card-title>
      Recordings
    </b-card-title>

    <section v-if="loading">
      <p>Loading...</p>
    </section>

    <section v-else>
      <!-- No Recordings -->
      <section v-if="recordingState === 'none'">
        <p>No Recordings are available for this call</p>
      </section>

      <!-- Processing -->
      <section v-else-if="recordingState === 'processing'">
        <p>Recordings for this call are still being processed. Please check back shortly.</p>
      </section>

      <!-- Recordings -->
      <section v-else>
        <section class="mt-2">
          <label for="recordings">Recording</label>
          <select
            id="recordings"
            v-model="selectedRecordingId"
            class="form-control"
            @change="selectRecording($event)"
          >
            <option
              v-for="recording in recordings"
              :key="recording._id"
              :value="recording._id"
            >
              Recording {{ recording.clip_number }}
            </option>
          </select>
        </section>
        <section v-if="videoUrl" class="mt-2">
          <video
            class="pointer video-player-box"
            controls
            :src="videoUrl"
            @click="play($event)"
          />
        </section>
        <section class="mt-2">
          <button
            :disabled="!downloadAvailable"
            class="btn btn-success btn-sm btn-block"
            @click="downloadRecordings()"
          >
            <span class="fas fa-sm fa-download" />
            Download Recordings
          </button>
        </section>
      </section>
    </section>
  </b-card>
</template>

<style type="text/css">
.video-player-box {
  max-width: 100%;
}

.video-js {
  max-width: 100%;
}
</style>

<script>
import VisitService from '@/services/VisitService';
import { logger } from '../../util/logger';

export default {
  name: 'VisitRecordings',
  props: {
    visit: {
      type: Object,
      required: true,
    },
    otp: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      recordingState: 'none',
      recordings: [],
      selectedRecordingId: null,
      downloadLink: null,
      downloadAvailable: false,
      videoUrl: null,
      playerOptions: {
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
      },
    };
  },
  mounted() {
    this.getRecordingsAndState();
  },
  methods: {
    play(e, btn) {
      document.querySelectorAll('.video-card').forEach(elm => {
        const video = elm.querySelector('video');
        video.removeAttribute('controls');
        elm.classList.remove('playing');
        video.pause();
      });

      const video = btn ? e.target.previousSibling : e.target;

      if (video) {
        video.setAttribute('controls', true);
        video.play();
        video.parentElement.classList.add('playing');
      }
    },
    getRecordingsAndState() {
      if (this.visit.recording_status === 'ready') {
        this.recordingState = 'ready';
        this.getRecordingsAndDownloadLink();
      } else if (this.visit.recording_status === 'processing') {
        this.recordingState = 'processing';
        this.loading = false;
      } else {
        this.recordingState = 'none';
        this.loading = false;
      }
    },
    getRecordingsAndDownloadLink() {
      VisitService.getRecordingsAndDownloadLink(this.visit._id, this.otp).then(res => {
        this.recordings = res.data.recordings;
        if (this.recordings && this.recordings.length > 0) {
          this.recordings = this.recordings.sort((r1, r2) => r1.clip_number - r2.clip_number);
          this.playerOptions.sources = [
            {
              type: 'video/mp4',
              src: this.recordings[0].file_url,
            },
          ];
          this.selectedRecordingId = this.recordings[0]._id;
          this.videoUrl = this.recordings[0].file_url;
        }
        this.downloadLink = res.data.download_link;
        this.downloadAvailable = true;
        this.loading = false;
        console.log('got otp with download link', res.data);
      }).catch(err => {
        // OTP issue
        if (err.response && err.response.status === 403) {
          // Let the parent know something went wrong with the OTP
          this.$parent.$emit('otpIssue');
        } else {
          logger.error('Error getting recordings and download link', err, { visitId: this.visit._id }, 'VisitRecordings:getRecordingsAndDownloadLink');
          this.$toast.error('Error getting recordings for visit. Please check your connection and refresh the page.', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }
        console.log('error request', err);
      });
    },
    selectRecording(event) {
      const selectedId = event.target.value;
      this.selectedRecordingId = selectedId;
      const recordingToView = this.recordings.find(recording => {
        if (recording._id === selectedId) {
          return recording;
        }
      });
      if (recordingToView) {
        this.videoUrl = recordingToView.file_url;
        // this.playerOptions.sources = [
        //   {
        //     type: 'video/mp4',
        //     src: recordingToView.file_url,
        //   },
        // ];
      }
    },
    downloadRecordings() {
      this.$toast.info('Fetching downloading....');
      const downloadElement = document.createElement('a');
      downloadElement.download = `recordings-${this.visit._id}`;
      downloadElement.href = this.downloadLink;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      downloadElement.remove();
      this.$toast.success('Beginning Download...', {
        toastClassName: ['toast-success', 'warning-toast'],
      });
      this.recordDownloadEvent();
    },
    recordDownloadEvent() {
      VisitService.createDownloadRecordingEvent(this.visit._id).then(res => {
        console.log('created recording event', res);
      }).catch(err => {
        console.log('could not create recording event', err);
        logger.error('Error creating audit log recording download event', err);
      });
    },
  },
};
</script>
